import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { MdClear } from "react-icons/md";
import './ValidarHabitacion.css';

const PopUpValidaHabitacion = (props) => {
	const [t] = useTranslation("global");

	useEffect(() => {
		

	}, []);
	
	const confirmar = () => {
		
		// Close popup
		props.toggle();
		
		props.validaHabitacion();			
	}
	
	const cancelar = () => {

		// Close popup
		props.toggle();
	}
	
	return (
		<div className="popup">
			<div className="popup-inner-confirmLogOut">
				<div className="popup-Header">
					<h1 className={"popup-Title"}>{t("app.habitacion.popupValidarTitulo")}</h1>
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>

				<div className="popup-Content-confirmLogOut">
					<form className="form-nuevaCama">
						<div className="popup-div-inputs">
							<p className="confirmText">{t("app.habitacion.popupValidarContenido")}</p>
							
							<div className="popup-div-buttons">
								<button type="button" className="btn-general-colorPink" onClick={cancelar}>{t("app.label.no")}</button>
								<button type="button" className="btn-general" onClick={confirmar}>{t("app.label.si")}</button>
							</div>
							
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpValidaHabitacion